
jQuery(function ($) {
  "use strict";

  // テーブルの行をリンクにする
  $('tbody tr[data-href]').addClass('clickable').on('click',function () {
    window.location = $(this).attr('data-href');
  }).find('a').on({
    function() {
      $(this).parents('tr').off('click');
    },
    function() {
      $(this).parents('tr').on('click',function () {
        window.location = $(this).attr('data-href');
      });
    }
  });
});
